import * as yup from 'yup'
import React, { useEffect } from 'react'
import Button from 'components/ui-kit/Button/index'
import Image from 'components/ui-kit/Image/index'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUserInformation } from 'redux-store/thunk/user.thunk'
import { getPrecision, numberWithCommas } from 'helpers/common.helpers'
import useGameSettingsUpdateSocketNameSpace from 'socket-resources/hooks/useGameSettingsUpdateSocketNameSpace'
import { getAllCurrency, getGameSetting } from 'redux-store/thunk/gameSettings.thunk'
import { updateGameSetting } from 'redux-store/redux/slices/gameSettings.slice'
import { userLogin } from 'redux-store/thunk/auth.thunk'
import { ROUTE_PATHS } from 'constants/index'
import { useLocation, useHistory } from 'react-router-dom'
import './Header.scss'

const NewHeader = () => {
  const showHeader = false // no need to show inside iframe
  const dispatch = useDispatch()
  const { search } = useLocation()
  const history = useHistory()
  const currencyCode = new URLSearchParams(search).get('currencyCode')
  const playerToken = new URLSearchParams(search).get('token')

  const { userInfo, isLoggedIn, isSessionOut } = useSelector((state) => state.auth)
  const listenGameSettingsUpdate = useGameSettingsUpdateSocketNameSpace()

  const handleLoginUser = () => {
    const params = {
      payload: {
        operatorId: 1, // TODO: update backend, no need to pass operatorId,
        operatorUserToken: playerToken,
        currencyCode
      },
      history
    }
    dispatch(userLogin(params))
  }

  useEffect(() => {
    if (playerToken && currencyCode) {
      handleLoginUser()
    } else {
      history.push(ROUTE_PATHS.home)
    }
  }, [playerToken, currencyCode])

  useEffect(() => {
    if (isSessionOut) {
      history.push(ROUTE_PATHS.home, { title: 'sessionOut', message: 'sessionOutMessage' })
    }
  }, [isSessionOut])

  useEffect(() => {
    dispatch(getAllCurrency())
    dispatch(getGameSetting())
    window.addEventListener('beforeunload', () => {
      // signOut()
    })
    const clearGameSettingsUpdate = listenGameSettingsUpdate(handleGameSettingsUpdate)

    return () => {
      clearGameSettingsUpdate()
    }
  }, [])

  const systemGameDataSchemas = yup.array().of(yup.object().shape({
    id: yup.string().required(),
    gameId: yup.number().required(),
    maxBet: yup.object(),
    minBet: yup.object(),
    maxProfit: yup.object(),
    houseEdge: yup.number().required(),
    minOdds: yup.number().required(),
    maxOdds: yup.number().required(),
    minAutoRate: yup.number().required(),
    createdAt: yup.string().required(),
    updatedAt: yup.string().required()
  })).min(1)

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(fetchUserInformation())
    }
  }, [isLoggedIn])

  const handleGameSettingsUpdate = async ({ data }) => {
    if (data) {
      const isValid = await systemGameDataSchemas.isValid(data)
      if (isValid) {
        dispatch(updateGameSetting(data))
      }
    }
  }

  const openExternalLink = (url = '') => {
    // window.parent.location = url
  }

  return (
    <>
      {showHeader && (
        <header className=''>
          <nav className='navbar navbar-expand navbar-dark'>
            <div className='container-fluid'>
              <span onClick={() => openExternalLink()} className='navbar-brand p-0 me-0 me-md-4'>
                <Image width={40} height={20} src='/assets/images/logo/logo.png' alt='logo' />
              </span>
              <div className='justify-content-end flex-grow-1' id='navbarScroll'>
                <ul className='navbar-nav flex-row my-2 my-lg-0 navbar-nav-scroll gap-2'>
                  <li className='nav-item ms-auto'>
                    <Button className='btn-static text-white navbar-wallet-btn d-flex justify-content-end align-items-center py-1 ps-2'>
                      <div className='d-flex'>
                        {userInfo?.wallet?.currency} {numberWithCommas(getPrecision(userInfo?.wallet?.balance))}
                      </div>
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
      )}
    </>
  )
}

export default NewHeader
